const BASE = String(import.meta.env.BASE_URL || '/').replace(/\/+$/, '');

export const SECTION_SLUGS = {
  overview: 'overview',
  campanhas: 'campaigns',
  contas: 'accounts',
  bms: 'bms',
  rejeitados: 'rejected',
  funil: 'funnel',
  relatorios: 'reports',
  importar: 'import',
  lojas: 'plataformas',
  vendas: 'vendas',
  produtos: 'produtos',
  tracker: 'tracker',
  notificacoes: 'notificacoes',
  admin: 'admin',
};

export const SLUG_TO_SECTION = Object.fromEntries(
  Object.entries(SECTION_SLUGS).map(([id, slug]) => [slug, id])
);
SLUG_TO_SECTION.integrations = 'lojas';
SLUG_TO_SECTION.plataformas = 'lojas';
SLUG_TO_SECTION.lojas = 'lojas';

export const G2_LEVEL_SLUGS = {
  contas: 'accounts',
  campanhas: '',
  conjuntos: 'adsets',
  anuncios: 'ads',
};

export const G2_SLUG_TO_LEVEL = {
  accounts: 'contas',
  adsets: 'conjuntos',
  ads: 'anuncios',
};

export const PAGINATED_SECTIONS = new Set(['campanhas', 'contas', 'lojas', 'vendas', 'produtos', 'bms', 'rejeitados', 'relatorios', 'admin']);

export const AUTH_SCREENS = new Set(['login', 'recuperar', 'set-password']);

export function buildHref({ section = 'overview', g2Level = null, page = 1, trackerId = '' } = {}) {
  let path = `/${SECTION_SLUGS[section] || 'overview'}`;
  if (section === 'campanhas') {
    const sub = G2_LEVEL_SLUGS[g2Level] || '';
    path = sub ? `/campaigns/${sub}` : '/campaigns';
  }
  if (section === 'tracker' && trackerId) path = `/tracker/${encodeURIComponent(trackerId)}`;
  const n = Math.max(1, Number(page) || 1);
  const query = PAGINATED_SECTIONS.has(section) && n > 1 ? `?page=${n}` : '';
  return `${BASE}${path}${query}`;
}

export function loginHref(next) {
  const path = `${BASE}/login`;
  if (!next || next === '/' || next === '/login' || AUTH_SCREENS.has(String(next).replace(/^\//, '').split('/')[0]) || next.startsWith('/login')) {
    return path;
  }
  return `${path}?next=${encodeURIComponent(next)}`;
}

export function recuperarHref() {
  return `${BASE}/recuperar`;
}

export function setPasswordHref(token) {
  const path = `${BASE}/set-password`;
  if (!token) return path;
  return `${path}?token=${encodeURIComponent(token)}`;
}

export function parseRoute(loc = window.location) {
  let pathname = String(loc.pathname || '/');
  if (BASE && pathname.startsWith(BASE)) pathname = pathname.slice(BASE.length) || '/';
  pathname = pathname.replace(/\/+$/, '') || '/';

  const params = new URLSearchParams(loc.search || '');
  const rawPage = parseInt(params.get('page') || '1', 10);
  const page = Number.isFinite(rawPage) && rawPage > 0 ? rawPage : 1;

  const parts = pathname === '/' ? [] : pathname.slice(1).split('/');
  const slug = parts[0] || 'overview';
  const sub = parts[1] || '';

  if (slug === 'login') {
    return { screen: 'login', section: null, g2Level: null, page: 1, valid: !sub };
  }
  if (slug === 'recuperar') {
    return { screen: 'recuperar', section: null, g2Level: null, page: 1, valid: !sub };
  }
  if (slug === 'set-password') {
    return { screen: 'set-password', section: null, g2Level: null, page: 1, valid: !sub, token: params.get('token') || '' };
  }

  if (slug === 'tracker') {
    return {
      screen: 'app',
      section: 'tracker',
      g2Level: null,
      page: 1,
      trackerId: parts.length === 2 ? sub : '',
      valid: parts.length <= 2,
    };
  }

  if (slug === 'campaigns') {
    if (sub && !G2_SLUG_TO_LEVEL[sub]) {
      return { screen: 'app', section: 'campanhas', g2Level: 'campanhas', page, valid: false };
    }
    return {
      screen: 'app',
      section: 'campanhas',
      g2Level: G2_SLUG_TO_LEVEL[sub] || 'campanhas',
      page,
      valid: true,
    };
  }

  const section = SLUG_TO_SECTION[slug];
  if (!section) return { screen: 'app', section: 'overview', g2Level: null, page: 1, valid: false };
  if (sub) {
    return {
      screen: 'app',
      section,
      g2Level: null,
      page: PAGINATED_SECTIONS.has(section) ? page : 1,
      valid: false,
    };
  }
  return {
    screen: 'app',
    section,
    g2Level: null,
    page: PAGINATED_SECTIONS.has(section) ? page : 1,
    valid: true,
  };
}

export function hrefMatches(href, loc = window.location) {
  return normalizeHref(href) === normalizeHref(`${loc.pathname}${loc.search}`);
}

function normalizeHref(href) {
  try {
    const u = new URL(href, window.location.origin);
    const path = u.pathname.replace(/\/+$/, '') || '/';
    return `${path}${u.search}`;
  } catch {
    return href;
  }
}

export function isPlainClick(e) {
  return e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;
}
